import { useScrollReveal } from '@/hooks/useScrollReveal';

type Direction = 'up' | 'down' | 'left' | 'right' | 'none';

interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  threshold?: number;
  direction?: Direction;
  delay?: number;
}

const initialTransform: Record<Direction, string> = {
  up: 'translate-y-12',
  down: '-translate-y-12',
  left: 'translate-x-12',
  right: '-translate-x-12',
  none: '',
};

export function ScrollReveal({
  children,
  className = '',
  threshold = 0.08,
  direction = 'up',
  delay = 0,
}: ScrollRevealProps) {
  const { ref, isVisible } = useScrollReveal({ threshold });

  return (
    <div
      ref={ref}
      className={`w-full transition-all duration-800 ease-reveal ${className} ${
        isVisible
          ? 'opacity-100 translate-y-0 translate-x-0'
          : `opacity-0 ${initialTransform[direction]}`
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}